import * as _ from 'lodash';
import Uuid from '../../../../support/Uuid';
import DecimalForGlobals from '../impuestos/DecimalForGlobals';

class DocumentoRelacionadoImpuestosCalculator {
  data = {};
  Moneda = null;

  constructor(data) {
    this.data = data;

    this.Moneda = data.Moneda;
  }

  static make(data) {
    return new DocumentoRelacionadoImpuestosCalculator(data);
  }

  apply() {
    let items = _.get(this.data, 'Conceptos.Concepto') || [];

    const traslados = this._getTraslados(items);
    const retenciones = this._getRetenciones(items);

    return {
      ...traslados,
      ...retenciones,
    };
  }

  _getTraslados(items) {
    let traslados = {};

    for (const item of items) {
      let impuestos = _.get(item, 'Impuestos.Traslados.Traslado', []);

      traslados = this._calculate(impuestos);
    }

    traslados = this._getValues(traslados);

    if (!traslados) {
      return {};
    }

    return {
      TrasladosDR: {
        TrasladoDR: traslados.map((item) => {
          return {
            id: Uuid.v4(),
            TasaOCuotaDR: !!item.TasaOCuota
              ? DecimalForGlobals.make(item.TasaOCuota).toString(6)
              : undefined,
            ...item,
          };
        }),
      },
    };
  }

  _getRetenciones(items) {
    let retenciones = {};

    for (const item of items) {
      let impuestos = _.get(item, 'Impuestos.Retenciones.Retencion', []);

      retenciones = this._calculate(impuestos);
    }

    retenciones = this._getValues(retenciones);

    if (!retenciones) {
      return {};
    }

    return {
      RetencionesDR: {
        RetencionDR: retenciones.map((item) => {
          return {
            id: Uuid.v4(),
            TasaOCuotaDR: !!item.TasaOCuota
              ? DecimalForGlobals.make(item.TasaOCuota).toString(6)
              : undefined,
            ...item,
          };
        }),
      },
    };
  }

  _getValues(values) {
    values = Object.values(values);

    if (values.length === 0) {
      return null;
    }

    return values;
  }

  _calculate(impuestos) {
    let index;
    let data = {};
    let result = {};

    for (const impuesto of impuestos) {
      if (impuesto.TipoFactor === 'Exento') {
        [data, index] = this._calculateExento(impuesto, result);
      } else {
        [data, index] = this._calculateImpuestos(impuesto, result);
      }

      result = {
        ...result,
        [index]: data,
      };
    }

    return result;
  }

  _calculateExento(impuesto, result) {
    const index = `${impuesto.Impuesto}-${impuesto.TipoFactor}`;

    let data = result[index] ?? null;

    if (data && this._isMXN()) {
      data.BaseDR = parseFloat(data.Base || 0) + parseFloat(impuesto.Base || 0);
    } else if (data && !this._isMXN()) {
      data.BaseDR = undefined;
    } else {
      data = {
        BaseDR: this._isMXN() ? impuesto.Base : undefined,
        ImpuestoDR: impuesto.Impuesto,
        TipoFactorDR: impuesto.TipoFactor,
      };
    }

    return [data, index];
  }

  _calculateImpuestos(impuesto, result) {
    const index = `${impuesto.Impuesto}-${impuesto.TipoFactor}-${impuesto.TasaOCuota}`;

    let data = result[index] ?? null;

    if (data && this._isMXN()) {
      data.BaseDR = parseFloat(data.Base || 0) + parseFloat(impuesto.Base || 0);
      data.ImporteDR = parseFloat(data.Importe || 0) + parseFloat(impuesto.Importe || 0);
    } else if (data && !this._isMXN()) {
      data.BaseDR = undefined;
      data.ImporteDR = undefined;
    } else {
      data = {
        BaseDR: this._isMXN() ? impuesto.Base : undefined,
        ImpuestoDR: impuesto.Impuesto,
        TipoFactorDR: impuesto.TipoFactor,
        TasaOCuotaDR: impuesto.TasaOCuota,
        ImporteDR: this._isMXN() ? impuesto.Importe : undefined,
      };
    }

    return [data, index];
  }

  _isMXN() {
    return this.Moneda === 'MXN';
  }
}

export default DocumentoRelacionadoImpuestosCalculator;
